module.exports = __webpack_public_path__ + "img/more-new.12a4e324.png";